import { useGetIdentity } from '@refinedev/core'
import Cookies from 'js-cookie'
type iUserIdentity = {
  permissions: string[]
}
const resourcePermissionMap: Record<string, string> = {
  usuario: 'usr_l',
  clientes: 'cli_l',
  caixa: 'cxa_l',
  catalogo: 'cat_l',
  fornecedores: 'for_l',
  orcamentos: 'orc_l',
  produtos: 'pro_l',
  compras: 'com_l',
  vendas: 'vnd_l',
  dashboard: 'dsh_v',
  contaspagar: 'cnp_l',
  contasreceber: 'cnr_l',
  grupolinha: 'gpl_l',
  marcas: 'mar_l',
}
const normalize = (value?: string) => value?.toLowerCase().trim() ?? ''

export const useValidatePermission = (permission: string) => {
  const { data: identity } = useGetIdentity<iUserIdentity>()

  let perms: string[] = []

  if (typeof identity?.permissions === 'string') {
    try {
      perms = JSON.parse(identity.permissions)
    } catch (e) {
      console.error('Erro ao converter permissions:', e)
      return false
    }
  } else if (Array.isArray(identity?.permissions)) {
    perms = identity!.permissions!
  }

  return perms.includes(permission)
}

export const accessControl = (resource: string | undefined) => {
  const permissions = JSON.parse(Cookies.get('permissions') || '[]')
  if (!resource) return { can: false }

  if (resource === 'eventos') return { can: true }

  const requiredPrefix = resourcePermissionMap[resource]

  if (!requiredPrefix) {
    return { can: permissions.includes(normalize(resource)) }
  }

  const can = permissions.some((p: string) => p.startsWith(requiredPrefix))
  return { can }
}
